// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"9752f257","468":"4ea5db73","488":"966c9dbd"}[chunkId] + ".chunk.js";
};